import { SmartCrossLinks } from 'src/app/App';

export default ({
  smartCrosslinks,
}: {
  smartCrosslinks: SmartCrossLinks;
}): string => {
  return smartCrosslinks?.globalVariables?.br_iuid || '';
};
